import { PlaceholderRow } from "@/app/types/common/PlaceholderRow";
import { UStyles } from "@/app/utils/UStyles";
import styles from "./BlurredPlaceholder.module.css";

type Props = {
  rows?: PlaceholderRow[];
  cellsCount?: number;
  withIcon?: boolean;
  gridColumns?: string;
  rowClassName?: string;
  className?: string;
};

export default function BlurredPlaceholder(props: Props) {
  const { rows, cellsCount, withIcon, gridColumns, rowClassName, className } = props;

  // Generate rows if not provided
  const actualRows: PlaceholderRow[] =
    rows ||
    Array(5)
      .fill(null)
      .map(() => ({
        withIcon: withIcon || false,
        cells: Array(cellsCount || 1)
          .fill(null)
          .map((_, j) => ({
            width: j === 0 ? `${60 + Math.random() * 20}%` : "60px",
            pill: j > 0 && j % 2 !== 0,
          })),
      }));

  return (
    <ul className={UStyles.classNames(styles.list, className)}>
      {actualRows.map((row, i) => (
        <li
          key={i}
          className={UStyles.classNames(styles.row, rowClassName)}
          style={gridColumns ? { gridTemplateColumns: gridColumns } : undefined}
        >
          {row.cells.map((cell, j) => {
            if (j === 0 && row.withIcon) {
              return (
                <div key={j} className={styles.iconCell}>
                  <div className={styles.icon} />
                  <div className={styles.bar} style={{ width: cell.width }} />
                </div>
              );
            }
            if (cell.circle) {
              return (
                <div
                  key={j}
                  className={styles.circle}
                  style={{ width: cell.width, height: cell.width }}
                />
              );
            }
            if (cell.pill) {
              return (
                <div
                  key={j}
                  className={styles.pill}
                  style={{ width: cell.width, minWidth: cell.width, maxWidth: cell.width }}
                />
              );
            }
            return (
              <div
                key={j}
                className={styles.bar}
                style={{ width: cell.width, minWidth: cell.width, maxWidth: cell.width }}
              />
            );
          })}
        </li>
      ))}
    </ul>
  );
}
